import { render } from "./UserParentSalon.vue?vue&type=template&id=7f2b0830"
import script from "./UserParentSalon.vue?vue&type=script&lang=js"
export * from "./UserParentSalon.vue?vue&type=script&lang=js"

import "./UserParentSalon.vue?vue&type=style&index=0&id=7f2b0830&lang=scss"

import exportComponent from "/Users/gardener/OpenideProjects/Navigator_frontend/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__